import { IUser } from '@shared/interfaces/IUser';
// eslint-disable-next-line import/no-cycle
import { initPostHogByUserData } from '@shared/utils/posthog.utils';
import { Environments } from '@shared/constants/environments';
import { initSentryUser } from '@shared/utils/monitoring.util';
// eslint-disable-next-line import/no-cycle
import { biService } from '../servicesInitializer';

export const initBIByUserData = (userDetails: IUser): void => {
	biService.initUserIdentify({
		userId: userDetails._id,
		username: userDetails.username,
		email: userDetails.email,
		roleType: userDetails.permissions.roleType,
	});
};

export const initServicesDependentByUserData = (userDetails: IUser, projectId: string): void => {
	initBIByUserData(userDetails);
	initPostHogByUserData(userDetails, projectId, import.meta.env.REACT_APP_STAGE as Environments);
	initSentryUser(userDetails);
};
